<form [formGroup]="form" (ngSubmit)="submit()">
  <div class="mb-2">
    <label class="form-label">Lesson title *</label>
    <input class="form-control" formControlName="lessonTitle" />
  </div>

  <div class="mb-2">
    <label class="form-label">Lesson subject</label>
    <input class="form-control" formControlName="lessonSubject" />
  </div>

  <div class="mb-2">
    <label class="form-label">Instructions</label>
    <textarea class="form-control" rows="3" formControlName="lessonInstructions"></textarea>
  </div>

  <div class="row g-2 mb-2">
    <div class="col-md-6">
      <label class="form-label">Lesson type *</label>
      <select class="form-select" formControlName="lessonType">
        <option *ngFor="let t of lessonTypes" [value]="t">{{ t }}</option>
      </select>
    </div>

    <div class="col-md-6">
      <label class="form-label">Approx slide count *</label>
      <input type="text" class="form-control" formControlName="lessonSlideCount" placeholder="e.g. 25 or 70-75" />
    </div>
  </div>

  <div class="row g-2 mb-2">
    <div class="col-md-6">
      <label class="form-label">Delivered in person?</label>
      <select class="form-select" formControlName="lessonDeliveredInPerson">
        <option value="N">No</option>
        <option value="Y">Yes</option>
      </select>
    </div>
    <div class="col-md-6">
      <label class="form-label">Lesson content mode</label>
      <select class="form-select" formControlName="lessonContentMode">
        <option value="generic">Generic lesson</option>
        <option value="document_reference">Lesson referring to document</option>
        <option value="document_strict">Document-specific lesson</option>
      </select>
    </div>
  </div>

  <div class="mb-2" formGroupName="preferences">
    <label class="form-label">Use sections in TOC</label>
    <select class="form-select" formControlName="lessonSectionTOC">
      <option *ngFor="let o of ynnaOptions" [value]="o">{{ o }}</option>
    </select>
  </div>

  <div class="mb-2" formGroupName="preferences">
    <label class="form-label">Include assessment</label>
    <select class="form-select" formControlName="lessonAssessment">
      <option *ngFor="let o of ynnaOptions" [value]="o">{{ o }}</option>
    </select>
  </div>

  <div class="row g-2 mb-2" formGroupName="preferences" *ngIf="form.get('preferences.lessonAssessment')?.value === 'Y'">
    <div class="col-12">
      <label class="form-label fw-semibold">Assessment / quiz preferences</label>
    </div>
    <div class="col-md-6">
      <label class="form-label">Questions per section (0–3)</label>
      <input type="number" class="form-control" formControlName="lessonQuizPerSection" min="0" max="3" />
    </div>
    <div class="col-md-6">
      <label class="form-label">End-of-lesson quiz (0–20)</label>
      <input type="number" class="form-control" formControlName="lessonQuizEndCount" min="0" max="20" />
    </div>
    <div class="col-md-4">
      <label class="form-label">Simple (profile)</label>
      <input type="number" class="form-control" formControlName="lessonQuizSimpleCount" min="0" max="20" />
    </div>
    <div class="col-md-4">
      <label class="form-label">Complex (profile)</label>
      <input type="number" class="form-control" formControlName="lessonQuizComplexCount" min="0" max="20" />
    </div>
    <div class="col-md-4">
      <label class="form-label">Applied in final quiz</label>
      <input type="number" class="form-control" formControlName="lessonQuizAppliedFinalCount" min="0" max="20" />
    </div>
  </div>

  <div class="actions">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel.emit()">Cancel</button>
    <button type="submit" class="btn btn-success">Create</button>
  </div>
</form>

